const designCntntBg = (() => {
  const pageDesign = (document.getElementById("pageDesign") != null);
  if (pageDesign) {


    // let sW = window.innerWidth;
    // let sH = window.innerHeight;

    const elem = document.querySelectorAll('.js-cntnt-bg');
    const elemTrigger = document.querySelectorAll('.js-cntnt-bg-trigger');

    for (let i = 0; i < elem.length; i++) {

      ScrollTrigger.create({
        trigger: elemTrigger[i],
        start: "0% 80%",
        toggleClass: { targets: elem[i], className: "act" },
        once: true, // 着脱を繰り返したくない場合(一度だけclass付与)
        // markers: true,
      });

    }




  }
})()
export default designCntntBg;